var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderButtonSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2,
    y: -1.68311,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1px)",
      clipPath: "url(#bgblur_0_2095_6989_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 2,
    cx: 16,
    cy: 16.3169,
    r: 15,
    fill: "#F6F6F6",
    fillOpacity: 0.38,
    stroke: "#2B2B2B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2095_6989_clip_path",
    transform: "translate(2 1.68311)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.3169,
    r: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderButtonSecondary);
export default __webpack_public_path__ + "static/media/slider_button_secondary.c8b9463949cae52e86468afb188ea7df.svg";
export { ForwardRef as ReactComponent };